<template>
  <dropdown-new :value="value"
                :options="options"
                :multiple="multiple"
                :tags="multiple"
                :placeholder="placeholder"
                @change="onChanged">
  </dropdown-new>
</template>

<script>
  let isFetched = false;

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: true
      },

      placeholder: String
    },

    data: () => ({
      value: []
    }),

    created() {
      if (!isFetched) {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('fetchRegulationsParagraphsFromCatalog');
            isFetched = true;
          }
          catch(e) {
            console.error('unable to fetch list of bid rules', e);
            this.globalErrorHandler(e);
          }
        });
      }
    },

    computed: {
      options: {
        get() {
          return this.$store.getters.regulationsParagraphs.items.map(e => ({
            id: e.id,
            name: e.code,
            description: e.description
          }));
        }
      }
    },

    methods: {
      onChanged(value) {
        this.value = value;
        const result = this.value.map(v => _.get(_.find(this.options, {id: v.id}), 'description'));
        this.$emit('input', result);
      }
    }
  }
</script>

<style scoped>

</style>
